import { styled } from '@mui/material';

import { useI18n } from '@app-velocity/i18n';

const StyledCurrentPlan = styled('div')(({ theme }) => ({
  fontSize: 12,
  fontWeight: 700,
  textAlign: 'center',
  padding: `${theme.spacing(3)} ${theme.spacing(4)}`,
  lineHeight: 1.75,
  background: 'var(--button-button-primary-color)',
  borderRadius: theme.spacing(5),
}));

export const CurrentPlan = () => {
  const { t } = useI18n();

  return <StyledCurrentPlan>{t('payments:current_plan')}</StyledCurrentPlan>;
};
